export default {
  base_url: '',
  routes: {
    api_media_get_media: {
      tokens: [['text', '/media/medias/list']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_get_live_pagination: {
      tokens: [['text', '/lives/Lives-pagination-grape']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_templateDisplay_post_screen_shot_html: {
      tokens: [['text', '/templateDisplay/screen-shot-html']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_screenDisplay_get_screen: {
      tokens: [['text', '/screenDisplay/get-one/']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_templateDisplay_get_template: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/templateDisplay/get-one']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_programDisplay_get_params_display: {
      tokens: [['text', '/programDisplay/params-display']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_screenDisplay_post_add_edit_screen: {
      tokens: [['text', '/screenDisplay/add-edit']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_get_list_playlists_pagination: {
      tokens: [['text', '/playlist/list-pagination']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },

    api_templateDisplay_post_add_edit_template: {
      tokens: [['text', '/templateDisplay/add-edit']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_bloc_post_thumb: {
      tokens: [['text', '/bloc/upload/thumb']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_bloc_get_images_stored: {
      tokens: [['text', '/video-api/bloc/stored/images']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_screenDisplay_get_existant_screen: {
      tokens: [['text', '/screenDisplay/screen-existance']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_screenDisplay_check_existence_disposition: {
      tokens: [['text', '/screenDisplay/disposition-existence']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_screenDisplay_get_all_disposition: {
      tokens: [['text', '/screenDisplay/list-dispositions']],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_screenDisplay_edit_title_disposition: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/screenDisplay/edit-title-disposition']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_screenDisplay_post_edit_screen: {
      tokens: [['variable', '/', '\\d+', 'id'], ['text', '/screenDisplay/edit-screen-title']],
      defaults: [],
      requirements: {
        id: '\\d+',
      },
      hosttokens: [],
    },
    api_templateDisplay_get_templates_by_rmbox: {
      tokens: [
        ['text', '.json'],
        ['variable', '/', '[^/]++', 'idRmbox'],
        ['text', '/templateDisplay/templates-by-rmbox'],
      ],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    api_templateDisplay_get_templates_by_program: {
      tokens: [
        ['text', '.json'],
        ['variable', '/', '[^/]++', 'idProgram'],
        ['text', '/templateDisplay/templates-by-program'],
      ],
      defaults: [],
      requirements: [],
      hosttokens: [],
    },
    /*Todo add api routing playlist*/
  },
  prefix: '',
  host: 'localhost',
  scheme: 'http',
};



// WEBPACK FOOTER //
// ./src/core/router/fos_js_routes_export_default.js